"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _reactTextareaAutosize = _interopRequireDefault(require("react-textarea-autosize"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _withFieldWrapper = _interopRequireDefault(require("../hocs/withFieldWrapper"));

var _mask = require("../../utils/mask");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  "formWrapper": "index__formWrapper",
  "formBtn": "index__formBtn",
  "formBtnCancel": "index__formBtnCancel",
  "formLink": "index__formLink",
  "withoutOpd": "index__withoutOpd",
  "formLabel": "index__formLabel",
  "formLabelRequired": "index__formLabelRequired",
  "formLabelOptional": "index__formLabelOptional",
  "formInput": "index__formInput",
  "formTextarea": "index__formTextarea",
  "formSection": "index__formSection",
  "formSectionRow": "index__formSectionRow",
  "formSectionBtn": "index__formSectionBtn",
  "error": "index__error",
  "compositeError": "index__compositeError",
  "fileInput": "index__fileInput",
  "fileControls": "index__fileControls",
  "formDateSelect": "index__formDateSelect",
  "formMoneySelect": "index__formMoneySelect",
  "amountField": "index__amountField",
  "currencyField": "index__currencyField",
  "imagePreview": "index__imagePreview",
  "dangerBtn": "index__dangerBtn",
  "dangerBtnDisabled": "index__dangerBtnDisabled",
  "fileList": "index__fileList",
  "fileItem": "index__fileItem",
  "downloadButton": "index__downloadButton",
  "downloadButtonDisabled": "index__downloadButtonDisabled",
  "fileButtonGroup": "index__fileButtonGroup",
  "timeIndicator": "index__timeIndicator",
  "modalButtonGroup": "index__modalButtonGroup"
};

var Input = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Input, _Component);

  var _super = _createSuper(Input);

  function Input() {
    var _this;

    (0, _classCallCheck2["default"])(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (e) {
      return _this.props.onChange(e.target.value);
    });
    return _this;
  }

  (0, _createClass2["default"])(Input, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fieldType = _this$props.fieldType,
          _this$props$input = _this$props.input,
          name = _this$props$input.name,
          value = _this$props$input.value,
          settings = _this$props.settings,
          disabled = _this$props.disabled;
      var mask = (0, _ramda.prop)('mask', settings);
      var placeholder = (0, _ramda.prop)('placeholder', settings);
      var inputMask = mask && (0, _mask.getMask)(mask);
      return (0, _ramda.path)(['textarea'], settings) ? /*#__PURE__*/_react["default"].createElement(_reactTextareaAutosize["default"], {
        id: name,
        className: "textarea ".concat(styles.formTextarea),
        minRows: 3,
        onChange: this.onChange,
        value: value,
        placeholder: placeholder,
        disabled: disabled
      }) : inputMask ? /*#__PURE__*/_react["default"].createElement(_reactTextMask["default"], {
        id: name,
        className: "input ".concat(styles.formInput),
        value: value,
        placeholder: placeholder,
        type: "text",
        onChange: this.onChange,
        mask: inputMask,
        placeholderChar: "\u2000",
        keepCharPositions: false,
        disabled: disabled,
        guide: true
      }) : /*#__PURE__*/_react["default"].createElement("input", {
        id: name,
        className: "input ".concat(styles.formInput),
        value: value,
        placeholder: placeholder,
        type: fieldType,
        onChange: this.onChange,
        disabled: disabled
      });
    }
  }]);
  return Input;
}(_react.Component);

(0, _defineProperty2["default"])(Input, "defaultProps", {
  fieldType: 'text'
});

var _default = (0, _withFieldWrapper["default"])(Input);

exports["default"] = _default;